/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';
import { chartLegendStyle, swatchStyle } from './ChartLegend.styles';

export interface LegendItem {
  /** 견본 색. theme 값을 호출부에서 전달. */
  color: string;
  label: ReactNode;
  /** true면 빈 견본(테두리만). "예정" 상태에 활용. */
  outline?: boolean;
}

export interface ChartLegendProps {
  items: LegendItem[];
}

/** 색 견본 범례. 편성표·히트맵의 상태색 안내에 활용. */
export function ChartLegend({ items }: ChartLegendProps) {
  return (
    <span css={chartLegendStyle}>
      {items.map((item, i) => (
        <span key={i}>
          <span css={swatchStyle(item.color, item.outline)} />
          {item.label}
        </span>
      ))}
    </span>
  );
}
